import { useEffect } from "react";
import { useImmer } from "use-immer";
import { connectStripeAccountApi, disconnectStripeAccountApi, getStripeConnectListApi, getStripeConnectVerifyApi } from "../api/stripeConnectApi";
import { errorMessage, SITE_URL, successMessage } from "../../../utils";
import { useLocation } from "react-router-dom";
import { usePermission } from "../../../shared";

export const useStripeConnect = () => {
    const location = useLocation();
    const isEditable = usePermission("integration-modify");

    const [state, setState] = useImmer({
        isLoading: true,
        allDataList: [],
        dataList: [],
        filter: {
            searchText: "",
            status: null,
        },
        isOpenConnect: false,
        selectedStore: {
            id: null,
            name: "",
        },
        isSaveButton: false,
    });

    useEffect(() => {
        getStripeConnectList();
    }, []);

    const getStripeConnectList = async () => {
        try {
            setState((draft) => {
                draft.isLoading = true;
            });

            const res = await getStripeConnectListApi();

            if (res.success) {
                setState((draft) => {
                    draft.isLoading = false;
                    draft.allDataList = res.data;
                    draft.dataList = res.data;
                });
            }
        } catch (err) {
            setState((draft) => {
                draft.isLoading = false;
            });
        }
    };

    // 🔹 Apply both search & filter together
    const applyFilters = (draft) => {
        const { searchText, status } = draft.filter;


        draft.dataList = draft.allDataList.filter((item) => {
            const matchesName = item.name
                ?.toLowerCase()
                .includes(searchText.toLowerCase());

            const matchesStatus = status !== null ? item.stripe_connect_status == status : true;


            return matchesName && matchesStatus;
        });
    };

    // 🔹 Handle search input
    const handleTableSearch = (event) => {
        const { value } = event.target;

        setState((draft) => {
            draft.isLoading = false;
            draft.filter.searchText = value;
            applyFilters(draft);
        });
    };

    // 🔹 Handle status filter
    const handleStatusFilter = (event) => {
        const { value } = event.target
        setState((draft) => {
            draft.isLoading = false;
            draft.filter.status = value || null;
            applyFilters(draft);
        });
    };

    const resetFilter = () => {
        setState((draft) => {
            draft.filter.status = null;
            draft.filter.searchText = "";
            applyFilters(draft);
        });
    }

    const handleModal = (type, state, data) => {
        switch (type) {
            case "connect":
                setState((draft) => {
                    draft.isOpenConnect = state;
                    draft.selectedStore = data;
                });
                break;
            default:
                break;
        }
    }

    const handleStoreConnect = (selectedStore) => {
        if (selectedStore.stripe_connect_status == "1") {
            handleStoreDisconnectApi()
        } else {
            handleStoreConnectApi()
        }
    }

    const handleStoreConnectApi = async () => {
        try {
            setState((draft) => {
                draft.isSaveButton = true;
            });
            let redirect_url = `${SITE_URL}stripe-connect`;

            const res = await connectStripeAccountApi(state.selectedStore.id, redirect_url);

            if (res.success) {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                if (res.data.stripe_connect_url) {
                    window.open(res.data.stripe_connect_url, "_blank");
                }
                handleModal("connect", false, null);
                getStripeConnectList();

            } else {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                errorMessage(res.message);
            }
        } catch (err) {
            setState((draft) => {
                draft.isSaveButton = false;
            });
        }
    }

    const handleStoreDisconnectApi = async () => {
        try {
            setState((draft) => {
                draft.isSaveButton = true;
            });

            const res = await disconnectStripeAccountApi(state.selectedStore.stripe_account_id, state.selectedStore.id);

            if (res.success) {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                handleModal("connect", false, null);
                getStripeConnectList();

            } else {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                errorMessage(res.message);
            }
        } catch (err) {
            setState((draft) => {
                draft.isSaveButton = false;
            });
        }
    }



    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const scope = queryParams.get('scope');
        const code = queryParams.get('code');
        const state = queryParams.get('state');

        if (code && scope && state) {
            verifySripeConnect(scope, code, state);

            // Clean the URL after processing the parameters
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
        }
    }, [location.search]);

    const verifySripeConnect = async (scope, code, state) => {
        try {
            const response = await getStripeConnectVerifyApi(scope, code, state);

            if (response.success) {
                successMessage(response.message);
                // Refresh the list to show the updated connection status
                getStripeConnectList()
            } else {
                errorMessage(response.message);
            }
        } catch (error) {
            errorMessage(error.response?.data?.message);

        };
    }

    return {
        state,
        isEditable,
        handleTableSearch,
        handleStatusFilter,
        resetFilter,
        handleModal,
        handleStoreConnect,
    };
};
